import { FormDivider } from '@/components/formComponents';

const ErrorBlock = () => {
    window.scrollTo(0, 0);
    return (
        <>
            <FormDivider />
            <div className="text-red-600 text-lg p-2 mb-2 flex justify-center items-center bg-red-100 text-center">
                <span>
                    The form has errors, please check the fields with a red
                    border.
                </span>
            </div>
            <FormDivider />
        </>
    );
};

export default ErrorBlock;
